import axios from 'axios'

// Thin wrapper over the /api/email-campaigns endpoints. `url` is the Redux base
// url prop (state.url), passed in from the page component.
const base = (url) => `${url || ''}/api/email-campaigns`

export const getMeta = (url) =>
  axios.get(`${base(url)}/meta`).then(r => r.data)

export const listTemplates = (url) =>
  axios.get(`${base(url)}/templates`).then(r => r.data)

export const getTemplate = (url, id) =>
  axios.get(`${base(url)}/templates/${id}`).then(r => r.data)

export const createTemplate = (url, body) =>
  axios.post(`${base(url)}/templates`, body).then(r => r.data)

export const updateTemplate = (url, id, body) =>
  axios.put(`${base(url)}/templates/${id}`, body).then(r => r.data)

export const previewAudience = (url, filter) =>
  axios.post(`${base(url)}/audience/preview`, filter).then(r => r.data)

export const previewRender = (url, body) =>
  axios.post(`${base(url)}/preview-render`, body).then(r => r.data)

export const listCampaigns = (url) =>
  axios.get(`${base(url)}/campaigns`).then(r => r.data)

export const getCampaign = (url, id) =>
  axios.get(`${base(url)}/campaigns/${id}`).then(r => r.data)

export const createCampaign = (url, body) =>
  axios.post(`${base(url)}/campaigns`, body).then(r => r.data)

export const testCampaign = (url, id) =>
  axios.post(`${base(url)}/campaigns/${id}/test`).then(r => r.data)

export const dryRunCampaign = (url, id) =>
  axios.post(`${base(url)}/campaigns/${id}/dry-run`).then(r => r.data)

export const sendCampaign = (url, id) =>
  axios.post(`${base(url)}/campaigns/${id}/send`).then(r => r.data)

export const getCampaignRecipients = (url, id, excludeTest = true) =>
  axios.get(`${base(url)}/campaigns/${id}/recipients`, { params: { excludeTest } }).then(r => r.data)

export const getCampaignStats = (url, id) =>
  axios.get(`${base(url)}/campaigns/${id}/stats`).then(r => r.data)
